import React from 'react';

const focusText = `본 서비스는 (주)핀릿(유사투자자문사)과의 제휴를 통해 제공되는 서비스 입니다.

• 당사는 (주)핀릿(유사투자자문사)으로 부터 AI포커스 서비스의 투자정보를 수신하며, 제공되는 정보는 신뢰할 만한 자료 및 정보로부터 얻어진 것이나 그 정확성이나 완전성을 보장할 수 없고 시간이 경과함에 따라 변경될 수 있습니다. 따라서 정보의 오류, 누락에 대하여 자료를 제공하는 회사에서는 그 결과에 대해 법적인 책임을 지지 않습니다.
• AI포커스 서비스는 불특정 다수를 대상으로 하는 투자조언만 가능합니다.
• 본 서비스의 투자정보는 투자권유 및 투자광고가 아닙니다.
• 본 서비스는 로보어드바이저와 무관합니다.
• 본 서비스에서 제공하는 데이터는 당사의 공식적인 조사 분석자료를 공표하는 것이 아닙니다.
• KRX에서 제공되는 데이터를 기반으로 AI포커스의 자체 알고리즘을 통해 분석됩니다.

본 서비스에서 제공되는 모든 정보는 투자판단에 대한 참고 자료로 투자에 대한 최종 판단과 책임은 투자자 본인에게 있으며, 원금 손실이 발생 할 수 있고 그 손실은 투자자에게 귀속 됩니다.`;

const signalText = `본 서비스는 (주)핀릿(유사투자자문사)과의 제휴를 통해 제공되는 서비스 입니다.

• 당사는 (주)핀릿(유사투자자문사)으로 부터 AI시그널의 투자정보를 수신하며, 제공되는 정보는 신뢰할 만한 자료 및 정보로부터 얻어진 것이나 그 정확성이나 완전성을 보장할 수 없고 시간이 경과함에 따라 변경될 수 있습니다. 따라서 정보의 오류, 누락에 대하여 자료를 제공하는 회사에서는 그 결과에 대해 법적인 책임을 지지 않습니다.
• AI시그널은 불특정 다수를 대상으로 하는 투자조언만 가능하며, 1:1 투자상담과 자금운용 서비스 제공이 일체 불가능합니다.
• 본 서비스의 투자정보는 투자권유 및 투자광고가 아닙니다.
• 본 서비스는 로보어드바이저와 무관합니다.
• 본 서비스에서 제공하는 데이터는 당사의 공식적인 조사 분석자료를 공표하는 것이 아닙니다.
• KRX에서 제공되는 데이터를 기반으로 AI시그널의 자체 알고리즘을 통해 분석됩니다.

본 서비스에서 제공되는 모든 정보는 투자판단에 대한 참고 자료로 투자에 대한 최종 판단과 책임은 투자자 본인에게 있으며, 원금 손실이 발생 할 수 있고 그 손실은 투자자에게 귀속 됩니다.`;

const ComplianceNote = ({ mode = 'focus' }) => {
  const text = mode === 'signal' ? signalText : focusText;

  // Render paragraphs: split by double newline into paragraphs, preserve single line breaks
  const paragraphs = text.split('\n\n');

  return (
    <div
      role="note"
      aria-label={`compliance-note-${mode}`}
      style={{padding: '0 18px', marginTop: '16px'}}
    >
      {paragraphs.map((para, idx) => (
        <p key={idx} style={{color: '#666', fontSize: 12, lineHeight: 1.6, margin: '6px 0'}}>
          {para.split('\n').map((line, i) => (
            <React.Fragment key={i}>{line}{i < para.split('\n').length - 1 ? <br/> : null}</React.Fragment>
          ))}
        </p>
      ))}
    </div>
  );
};

export default ComplianceNote;
